<template>
  <div class="wrap">
    <el-row :gutter="gutter" class="link-list">
      <el-col
        :xs="12"
        :sm="6"
        v-for="(item, index) in linkList"
        :key="'link' + index"
        class="el-item"
      >
        <a
          target="_blank"
          :href="item.link"
          :class="isCover ? 'isCover' : 'link-to-res'"
        >
          <div
            class="link-to-item"
            :class="{ more: item.type == 1 }"
            v-if="isCover"
          >
            <el-image
              v-if="item.type != 1"
              class="cover"
              fit="cover"
              :src="require('@/assets/images/csmz/' + (index + 1) + '.png')"
            ></el-image>
            <span class="link-txt" v-html="item.text2 ? item.text2 : item.text"
              ><i v-if="item.type == 1" class="iconfont icondata_next"></i
            ></span>
            <div class="goDetail-btn-wrap pc">
              <div class="goDetail-btn">
                <span>查看详情</span>
              </div>
            </div>
          </div>
          <div class="link-to-item" v-else>
            <span class="iconfont" :class="item.icon"></span>
            <div class="link-txt">
              {{ item.text }}
            </div>
          </div>
        </a>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { resourceList } from "../config";
export default {
  name: "resourceMenus",
  props: {
    gutter: {
      type: Number,
      default: 18,
    },
    isCover: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      linkList: resourceList,
    };
  },
};
</script>
<style lang="scss" scoped>
.container {
  a {
    text-decoration: none;
  }
  .link-list {
    .el-item {
      width: 16.6666%;
      .link-to-res {
        display: block;
        margin-top: 12px;
        text-align: center;
        cursor: pointer;
        &:hover {
          .link-to-item .link-txt {
            color: #dd0000;
          }
        }
        .link-to-item {
          & > .iconfont {
            display: block;
            margin-bottom: 12px;
            font-size: 68px;
            line-height: 68px;
            color: #dd0000;

            @media (max-width: 1200px) {
              margin-bottom: 8px;
              font-size: 50px;
              line-height: 50px;
            }
            @media (max-width: 992px) {
              margin-bottom: 6px;
            }
          }
          .link-txt {
            color: #444;
            font-size: 16px;
            line-height: 24px;
            height: 48px;
            @media (max-width: 767px) {
              font-size: 14px;
              line-height: 20px;
              height: 40px;
            }
          }
        }
      }
      .isCover {
        position: relative;
        margin-bottom: 25px;
        min-height: 70px;
        display: block;
        background-color: #f8f8f8;
        text-align: center;
        cursor: pointer;

        .link-to-item {
          position: relative;
          padding-bottom: 56.25%;

          &.more {
            background-color: #f7bb49;

            .link-txt {
              text-shadow: unset;
            }
            .goDetail-btn-wrap {
              display: none;
            }
            &:hover {
              background-color: #dea841;
            }
          }

          .cover {
            position: absolute;
            width: 100%;
            height: 100%;
            background-color: #eee;
          }
          .el-image {
            display: block;
          }
        }
        .link-txt {
          width: 100%;
          padding: 0 20px;
          font-size: 16px;
          color: #ffffff;
          text-align: center;
          line-height: 22px;
          text-shadow: 0 0 6px #888888;
          box-sizing: border-box;
          position: absolute;
          top: 50%;
          left: 0;
          transform: translateY(-50%);

          .iconfont {
            font-size: inherit;
          }
        }
        .goDetail-btn-wrap {
          display: none;
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
          cursor: pointer;
          background-color: rgba(0, 0, 0, 0.3);
          .goDetail-btn {
            width: 100%;
            position: absolute;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
            text-align: center;
            span {
              display: inline-block;
              height: 30px;
              line-height: 30px;
              padding: 0 20px;
              background: #dd0000;
              border-radius: 18px;
              font-size: 14px;
              color: #ffffff;
              @media (max-width: 992px) {
                height: 26px;
                line-height: 26px;
                padding: 0 10px;
                font-size: 12px;
              }
            }
          }
        }
        &:hover {
          .goDetail-btn-wrap {
            display: block;
          }
        }
      }
    }
  }
  @media (max-width: 992px) {
    .link-list {
      margin: 0 -6px !important;
      .el-item {
        padding: 0 6px !important;
        .isCover {
          margin-bottom: 15px;
          .link-txt {
            font-size: 14px;
            line-height: 18px;
          }
        }
      }
    }
  }
  @media (max-width: 767px) {
    margin-bottom: 18px;
    .link-list .el-item {
      width: 50%;
      .link-to-res {
        margin-top: 4px;
      }
    }
  }
}
</style>
